import React from 'react'
import Layout from '../components/layout'
import { Border } from '../components/IndexPage'
import { HeroContainer, Title } from '../components/SubIndex'
import privacy from '../content/pages/privacy.json'
import { Footer } from '../components/Footer'
import { Message } from '../components/MessageBar'
import '../css/video.css'
import heroVideo from '../assets/videos/ss_web_hero_2024.mp4'

const Privacy = () => {
  return(
    <Layout>
      <div className='relative z-0'>
        <div className='md:hidden'>
          <video loading='lazy' className='-mt-12 md:-mt-6 md:mb-0 w-full herovideo' autoPlay playsInline loop muted>
            <source src={heroVideo} type='video/mp4'/>
          </video>
        </div>
        <div className='hidden md:block md:w-full'>
          <video loading='lazy' className='-mt-12 md:-mt-6 md:mb-0 w-full herovideo' autoPlay playsInline loop muted>
            <source src={heroVideo} type='video/webm'/>
          </video>
        </div>
        <HeroContainer>
          <Title className=''>
            {privacy['h1-s1']}
            <Border thick className='mt-2 bg-primary' />
          </Title>
          <Message />
        </HeroContainer>
      </div>

      <div className='container p-8 lg:p-12 lg:px-16 lg:pt-16 lg:pb-8'>
        <div className='max-w-4xl mx-auto'>
          <p className='text-sm text-gray-600 mb-8 text-center'>{privacy.effective_date}</p>

          <section className='mb-8'>
            <h2 className='text-2xl text-primary font-semibold mb-4'>{privacy.introduction_title}</h2>
            <p className='text-sm leading-relaxed mb-6'>{privacy.introduction_content}</p>
          </section>

          <section className='mb-8'>
            <h2 className='text-2xl text-primary font-semibold mb-4'>{privacy.collection_title}</h2>
            <ul className='list-disc list-inside space-y-2'>
              {privacy.collection_content.map((item, idx) => (
                <li key={idx} className='text-sm leading-relaxed'>{item}</li>
              ))}
            </ul>
          </section>

          <section className='mb-8'>
            <h2 className='text-2xl text-primary font-semibold mb-4'>{privacy.sharing_title}</h2>
            <p className='text-sm leading-relaxed mb-4'>{privacy.sharing_content}</p>
            <ul className='list-disc list-inside space-y-2'>
              {privacy.sharing_list.map((item, idx) => (
                <li key={idx} className='text-sm leading-relaxed'>{item}</li>
              ))}
            </ul>
          </section>

          <section className='mb-8'>
            <h2 className='text-2xl text-primary font-semibold mb-4'>{privacy.security_title}</h2>
            <p className='text-sm leading-relaxed'>{privacy.security_content}</p>
          </section>

          <section className='mb-8'>
            <h2 className='text-2xl text-primary font-semibold mb-4'>{privacy.choices_title}</h2>
            <ul className='list-disc list-inside space-y-2'>
              {privacy.choices_content.map((item, idx) => (
                <li key={idx} className='text-sm leading-relaxed'>{item}</li>
              ))}
            </ul>
          </section>

          <section className='mb-8'>
            <h2 className='text-2xl text-primary font-semibold mb-4'>{privacy.changes_title}</h2>
            <p className='text-sm leading-relaxed'>{privacy.changes_content}</p>
          </section>

          <section className='mb-8'>
            <h2 className='text-2xl text-primary font-semibold mb-4'>{privacy.contact_title}</h2>
            <p className='text-sm leading-relaxed mb-4'>{privacy.contact_content}</p>
            <div className='bg-gray-50 p-4 rounded'>
              {privacy.contact_info.map((info, idx) => (
                <p key={idx} className='text-sm leading-relaxed'>{info}</p>
              ))}
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </Layout>
  )
}

export default Privacy
